var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confirm"},[_c('div',{staticClass:"wrap"},[_c('CotacntFormMail',{staticStyle:{"padding-top":"110px"},attrs:{"type":1}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }